import { render, staticRenderFns } from "./AppBarTipButton.vue?vue&type=template&id=64bb2e22"
import script from "./AppBarTipButton.vue?vue&type=script&lang=js"
export * from "./AppBarTipButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports